import React from 'react';
import styles from './RecipeList.module.css';
import { deleteRecipe as deleteRecipeService } from '@services/adminRecipeBookLocalService';

/**
 * Displays locally saved recipes with selection and deletion features.
 */
const RecipeList = ({ recipes, onSelectRecipe, onRefreshList }) => {

    /**
     * Manages recipe deletion confirmation and state synchronization.
     */
    const handleDelete = (e, id) => {
        e.stopPropagation();

        if (window.confirm("Are you sure you want to delete this recipe?")) {
            const result = deleteRecipeService(id);

            if (result.success && onRefreshList) {
                onRefreshList();
            }
        }
    };

    return (
        <div className={styles.recipesListLocal}>
            <h2 className={styles.localSubtitle}>Guardadas localmente</h2>
            <div className={styles.cardsContainer}>
                {recipes.map((item) => {
                    const recipeId = item._id || item.id;

                    return (
                        <div
                            key={recipeId}
                            className={styles.itemCard}
                            onClick={() => onSelectRecipe(item)}
                        >
                            <div className={styles.itemImage}>
                                <img
                                    src={item.image_url || item.imageUrl}
                                    alt={item.name}
                                />
                            </div>
                            <div className={styles.itemDetails}>
                                <h4 className={styles.recipeName}>{item.name}</h4>
                                <div className={styles.itemActions}>
                                    <span className={styles.itemBadge}>Local</span>

                                    <button
                                        className={styles.deleteButton}
                                        onClick={(e) => handleDelete(e, recipeId)}
                                        title="Delete recipe"
                                    >
                                        Eliminar
                                    </button>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default RecipeList;